"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEEddystoneUIDBuilder = exports.BLEEddystoneUID = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const BufferUtils_1 = require("../utils/BufferUtils");
const BLEEddystone_1 = require("./BLEEddystone");
const BLEUUID_1 = require("./BLEUUID");
const BLEBeaconObject_1 = require("./BLEBeaconObject");
const BLEService_1 = require("./BLEService");
let BLEEddystoneUID = class BLEEddystoneUID extends BLEEddystone_1.BLEEddystone {
    isValid() {
        return (super.isValid() && this.frame === 0x00 && this.namespaceId !== undefined && this.instanceId !== undefined);
    }
    computeUID() {
        let uid = new TextDecoder().decode(this.namespaceId.toBuffer());
        uid = (0, BufferUtils_1.toHexString)((0, BufferUtils_1.concatBuffer)(this.namespaceId.toBuffer(), this.instanceId.toBuffer()));
        return uid;
    }
    parseServiceData(uuid, serviceData) {
        super.parseServiceData(uuid, serviceData);
        if (uuid === undefined && serviceData === undefined) {
            return this;
        }
        if (!this.service) {
            return this;
        }
        if (this.frame !== 0x00) {
            return this; // Do not attempt to parse
        }
        this.namespaceId = BLEUUID_1.BLEUUID.fromBuffer(serviceData.slice(2, 12));
        this.instanceId = BLEUUID_1.BLEUUID.fromBuffer(serviceData.slice(12, 18));
        if (this.uid === undefined) {
            this.uid = this.computeUID();
        }
        return this;
    }
};
exports.BLEEddystoneUID = BLEEddystoneUID;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", BLEUUID_1.BLEUUID)
], BLEEddystoneUID.prototype, "namespaceId", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", BLEUUID_1.BLEUUID)
], BLEEddystoneUID.prototype, "instanceId", void 0);
exports.BLEEddystoneUID = BLEEddystoneUID = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], BLEEddystoneUID);
/**
 * BLE Eddystone UID builder
 */
class BLEEddystoneUIDBuilder extends BLEBeaconObject_1.BLEBeaconBuilder {
    constructor() {
        super();
        this.beacon = new BLEEddystoneUID();
        this.beacon.frame = 0x00;
        this.beacon.namespaceId = BLEUUID_1.BLEUUID.fromString(core_1.UUID.generate()
            .toString()
            .replace('-', '')
            .slice(0, 10 * 2 + 1));
        this.beacon.instanceId = BLEUUID_1.BLEUUID.fromString(core_1.UUID.generate()
            .toString()
            .replace('-', '')
            .slice(0, 6 * 2 + 1));
    }
    static create() {
        return new BLEEddystoneUIDBuilder();
    }
    static fromBeacon(beacon) {
        const builder = new BLEEddystoneUIDBuilder();
        builder.beacon = beacon;
        return builder;
    }
    namespaceId(namespaceId) {
        this.beacon.namespaceId = namespaceId;
        return this;
    }
    instanceId(instanceId) {
        this.beacon.instanceId = BLEUUID_1.BLEUUID.fromString(instanceId);
        return this;
    }
    calibratedRSSI(rssi) {
        this.beacon.calibratedRSSI = rssi;
        return this;
    }
    build() {
        return new Promise((resolve) => {
            // Eddystone Service
            const serviceData = new DataView(new ArrayBuffer(18), 0);
            serviceData.setUint8(0, 0x00); // Eddystone-UID frame
            serviceData.setInt8(1, this.beacon.getCalibratedRSSI(0, core_1.LengthUnit.METER));
            // Namespace ID
            const namespaceId = new DataView(this.beacon.namespaceId.toBuffer().buffer, 0);
            for (let i = 2; i < 2 + 10; i++) {
                serviceData.setUint8(i, namespaceId.getUint8(i - 2));
            }
            const instanceId = new DataView(this.beacon.instanceId.toBuffer().buffer, 0);
            for (let i = 12; i < 12 + 6; i++) {
                serviceData.setUint8(i, instanceId.getUint8(i - 12));
            }
            this.beacon.addService(new BLEService_1.BLEService(BLEUUID_1.BLEUUID.fromString('FEAA'), new Uint8Array(serviceData.buffer)));
            this.beacon.uid = this.beacon.computeUID();
            resolve(this.beacon);
        });
    }
}
exports.BLEEddystoneUIDBuilder = BLEEddystoneUIDBuilder;
//# sourceMappingURL=BLEEddystoneUID.js.map